const selectData = (state) => state.settings.mailboxProtection.self.data
const selectIntegrations = (state) => state.app.data.integrations
const selectLoader = (state) => state.settings.mailboxProtection.self.loader
const selectError = (state) => state.settings.mailboxProtection.self.error

const selectSelectedBannersLanguage = (state) =>
  state.settings.mailboxProtection.self.selectedBannersLanguage

export { selectData, selectLoader, selectError, selectIntegrations, selectSelectedBannersLanguage }
